import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  set(key: string, value: any): void {
    return localStorage.setItem(key, value);
  }

  setAndString(key: string, value: any): void {
    return localStorage.setItem(key, JSON.stringify(value));
  }


  get(key: string): any {
    return localStorage.getItem(key);
  }

  getAndParse(key: string): any {
    let stringVersion = localStorage.getItem(key);
    if (stringVersion) {
      return JSON.parse(stringVersion)
    } else {
      return undefined;
    }
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  clearStorage() {
    localStorage.clear();
  }
}
